export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑参数设置',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ amzControlParamsStatus }) => {
      return !['N'].includes(amzControlParamsStatus)
    },
  },
  {
    text: that.$l('menu_text_delete') || '删除参数设置',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ amzControlParamsStatus }) => {
      return !['N'].includes(amzControlParamsStatus)
    },
  },
  {
    text: that.$l('menu_text_confirm') || '审核参数设置',
    icon: 'el-icon-s-check',
    menuType: 'confirm',
    divided: true,
    allow: 'C',
    disabled: ({ amzControlParamsStatus }) => {
      return !['N'].includes(amzControlParamsStatus)
    },
  },
  {
    text: that.$l('menu_text_confirm_edit') || '审核修改参数设置',
    icon: 'el-icon-edit-outline',
    menuType: 'confirmEdit',
    allow: 'X',
    disabled: ({ amzControlParamsStatus }) => {
      return !['Y'].includes(amzControlParamsStatus)
    },
  },
  {
    text: that.$l('menu_text_copy') || '复制参数设置',
    icon: 'el-icon-copy-document',
    menuType: 'copy',
    divided: true,
    allow: 'P',
    disabled: ({ amzControlParamsStatus }) => {
      return ['D'].includes(amzControlParamsStatus)
    },
  },
]
